"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pellezzano": {
    "7d261a39": [{
      "hkey": "fd5d8938",
      "slug": "capezzano-inferiore",
      "name": "Capezzano Inferiore",
      "primary": true,
      "skipSearch": false
    }],
    "capezzano": [{
      "hkey": "fd5d8938",
      "slug": "capezzano-inferiore",
      "name": "Capezzano Inferiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65139f5a": [{
      "hkey": "417d65aa",
      "slug": "capezzano-cologna",
      "name": "Capezzano-Cologna",
      "primary": true,
      "skipSearch": false
    }],
    "cologna": [{
      "hkey": "417d65aa",
      "slug": "capezzano-cologna",
      "name": "Capezzano-Cologna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;